import React from "react";
import { Button, Col, Row, Image, Divider, Space } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import './QuestionContainer.css'; // Assuming you have a CSS file for additional styles

const QuestionContainer = ({ steps, currentStep, setCurrentStep }) => {
  const totalSteps = steps.length;

  const nextStep = () => setCurrentStep((current) => Math.min(current + 1, totalSteps - 1));
  const prevStep = () => setCurrentStep((current) => Math.max(current - 1, 0));
  let buttons = [];
  if (currentStep > 0) {
    buttons.push(
      <Button icon={<LeftOutlined />} size="large" onClick={prevStep} className="nav-button" />
    );
  }
  if (currentStep < totalSteps - 1) {
        buttons.push(
        <Button
            icon={<RightOutlined />}
            type="primary"
            size="large"
            onClick={nextStep}
            className="nav-button"
        />
        );
    }
  return (
    <div className="question-container">
      <Row justify="center" align="middle" className="question-content">
          <div style={{ padding: '20px' }}>
            {steps[currentStep].component}
          </div>
      </Row>
      <Row justify={'center'}>
                  {buttons}
      </Row>
    </div>
  );
};

export default QuestionContainer;
